import '@sparta.global.utilities/sparta-events-utility/dist/es6.js';

/* eslint-disable no-console */

/**
 * @name        Register Service Worker Utility
 * @file        sparta-register-sw-utility.js
 * @description register a service worker
 */

/**
 * @class RegisterSwUtility
 */
class RegisterSwUtility {
  /**
   * constructor
   */
  constructor() {
    this.init();
  }

  /**
   * initialize the utility
   * @returns { void } none
   */
  init() {
    this.registerServiceWorker();
  }

  /**
   * Get the Sparta build ID to append as a cache-busting query-param
   * @returns { string } the Sparta build ID
   */
  getSpartaBuildId() {
    const body = document.querySelector('body');
    if (body.dataset.buildId) {
      return parseInt(body.dataset.buildId, 0);
    }
    return 'no-build-id';
  }

  /**
   * Register the service worker
   * @returns { void } none
   */
  registerServiceWorker() {
    if (spaParams.siteParams.swRoot && typeof spaParams.siteParams.swRoot !== 'string') {
      console.error(`Service worker registration failed: spaParams.siteParams.swRoot returned type: ${typeof spaParams.siteParams.swRoot}`);
      return; // exit if swRoot is not set as a string
    } else if (typeof spaParams.siteName !== 'string') {
      console.error(`Service worker registration failed: spaParams.siteName returned type: ${typeof spaParams.siteName}`);
      return; // exit if siteName is not set as a string
    }
    const homepage = spaParams.siteName === 'homepage';
    let pathToSW;
    if (homepage) {
      // if registering on the homepage, do not use 'homepage' in the path
      pathToSW = '';
    } else if (spaParams.siteParams.swRoot) {
      pathToSW = `/${spaParams.siteParams.swRoot}`;
    } else {
      pathToSW = `/${spaParams.siteName}`;
    }
    pathToSW += `/sw.js?revision=${this.getSpartaBuildId()}`;

    // check if browser supports service workers
    if ('serviceWorker' in navigator) {
      // register the service worker
      navigator.serviceWorker.register(pathToSW).then(registration => {
        console.log(`Service worker registration successful with scope: ${registration.scope}`);
      }, error => {
        console.error(`Service worker registration failed: ${error}`);
      });
    } else {
      console.warn(`Service workers are not supported in ${navigator.userAgent}`);
    }
  }
}
var index = new RegisterSwUtility();

export { index as default };
